var map = {
	"./icon0.png": "cI3/",
	"./icon1.png": "Wtd5",
	"./icon_order.png": "QjUi",
	"./icon_地址备份@2x.png": "TZ7E"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1j6p";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/order ^\.\/icon.*\.png$
// module id = 1j6p
// module chunks = 1